export const RESET_PASSWORD: string = 'reset-password';
